import {
  ADD_DOCUMENT,
  SET_DOCUMENTS,
  CLEAR_DOCUMENTS,
  UPDATE_DOCUMENT,
  DELETE_DOCUMENT,
  SET_FETCHING_DOCUMENTS,
  SET_FETCHING_DOCUMENTS_ERROR,
  SET_SEARCH_TEXT,
  SYNC_DOCUMENTS_EVENTS,
  SYNC_DOCUMENTS_ROOMS,
  DETACH_EVENT_FROM_DOCUMENTS,
  DETACH_ROOM_FROM_DOCUMENTS,
  SET_MULTIPLE_DOCUMENTS_SELECTED,
  SET_IS_CREATING_DOCUMENT_FOLDER,
  SELECTED_PROPERTY_DOCUMENT_FOLDER_ID,
  SET_PROPERTY_DOCUMENT_FOLDERS,
  SET_PROPERTY_DOCUMENT_FOLDERS_TO_RENDER,
  SET_PROPERTY_FOLDERS_BREADCRUMBS,
  UPDATE_PROPERTY_DOCUMENT_FOLDER_TO_RENDER,
  ADD_PROPERTY_FOLDER,
  DELETE_PROPERTY_DOCUMENT_FOLDER,
} from '../reducers/documents';

export const acAddDocument = (document) => ({
  type: ADD_DOCUMENT,
  payload: document,
});

export const acSetDocuments = (documents) => ({
  type: SET_DOCUMENTS,
  payload: documents,
});

export const acSetPropertyDocumentFolders = (folders) => ({
  type: SET_PROPERTY_DOCUMENT_FOLDERS,
  payload: folders,
});

export const acSetPropertyDocumentFoldersToRender = (folders) => ({
  type: SET_PROPERTY_DOCUMENT_FOLDERS_TO_RENDER,
  payload: folders,
});

export const acSetPropertyFoldersBreadCrumbs = (folders) => ({
  type: SET_PROPERTY_FOLDERS_BREADCRUMBS,
  payload: folders,
});

export const acClearDocuments = () => ({
  type: CLEAR_DOCUMENTS,
});

export const acUpdateDocument = (document) => ({
  type: UPDATE_DOCUMENT,
  payload: document,
});

export const acDeleteDocument = (document) => ({
  type: DELETE_DOCUMENT,
  payload: document,
});

export const acSetFetchingDocuments = (fetching) => ({
  type: SET_FETCHING_DOCUMENTS,
  payload: fetching,
});

export const acSetFetchingDocumentsError = (error) => ({
  type: SET_FETCHING_DOCUMENTS_ERROR,
  payload: error,
});

export const acSetDocumentSearchText = (searchText) => ({
  type: SET_SEARCH_TEXT,
  payload: searchText,
});

export const acSyncDocumentsEvents = ({ documentIds, event, eventId }) => ({
  type: SYNC_DOCUMENTS_EVENTS,
  payload: {
    documentIds,
    event,
    eventId,
  },
});

export const acSyncDocumentsRooms = ({ documentIds, room, roomId }) => ({
  type: SYNC_DOCUMENTS_ROOMS,
  payload: {
    documentIds,
    room,
    roomId,
  },
});

export const acDetachEventFromDocuments = (eventId) => ({
  type: DETACH_EVENT_FROM_DOCUMENTS,
  payload: eventId,
});

export const acDetachRoomFromDocuments = (roomId) => ({
  type: DETACH_ROOM_FROM_DOCUMENTS,
  payload: roomId,
});

export const acSetMultipleDocumentsSelected = (multipleDocumentsSelected) => ({
  type: SET_MULTIPLE_DOCUMENTS_SELECTED,
  payload: multipleDocumentsSelected,
});

export const acSetIsCreatingDocumentFolder = (isCreatingDocumentFolder) => ({
  type: SET_IS_CREATING_DOCUMENT_FOLDER,
  payload: isCreatingDocumentFolder,
});

export const acSetSelectedPropertyFolderId = (id) => ({
  type: SELECTED_PROPERTY_DOCUMENT_FOLDER_ID,
  payload: id,
});

export const acUpdatePropertyDocumentFolderToRender = (folder) => ({
  type: UPDATE_PROPERTY_DOCUMENT_FOLDER_TO_RENDER,
  payload: folder,
});

export const acAddPropertyFolder = (breadcrumbs, newFolder) => ({
  type: ADD_PROPERTY_FOLDER,
  payload: { breadcrumbs, newFolder },
});

export const acDeletePropertyDocumentFolder = (folder) => ({
  type: DELETE_PROPERTY_DOCUMENT_FOLDER,
  payload: folder,
});
